import React from 'react';
import { Footer } from '../Components/Footer/Footer.js';
import './PageShowcase.css';

const strengths = [
  {
    title: 'Product mindset',
    description: 'I focus on what improves user outcomes first, then optimize implementation details.',
  },
  {
    title: 'Front-end craft',
    description: 'I build responsive interfaces with reusable components and consistent interaction patterns.',
  },
  {
    title: 'Collaboration',
    description: 'I enjoy shipping with teams and keeping communication clear from planning to release.',
  },
];

export const AboutMePage = () => {
  return (
    <>
      <main className="page-shell">
        <section className="page-content">
          <div className="page-hero">
            <span className="page-kicker">About Me</span>
            <h1>Developer focused on useful, reliable digital products</h1>
            <p>
              I am a full-stack developer with a strong front-end focus. I care about performance, accessibility,
              and predictable user flows. Outside coding, I enjoy visual design and turning rough ideas into clear,
              launch-ready experiences.
            </p>
          </div>

          <div className="page-grid">
            {strengths.map((item) => (
              <article className="page-card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};
